const FETCH_CUSTOMER_ACTIOHS = 'FETCH_CUSTOMER_ACTIOHS'
const REFRESH_CUSTOMER_ACTIONS = 'REFESH_CUSTOMER_ACTIONS'

export {
    FETCH_CUSTOMER_ACTIOHS,
    REFRESH_CUSTOMER_ACTIONS
}
